import { ReactElement, PropsWithChildren, useMemo } from 'react';
import {
  colorBgAutoFont,
  fontColorClassFromBgColor,
  colorHex,
  fontTypo
} from 'mt-react-theme-manager';
import { mixWithWhite } from '../../../../lib/color';

import './styles.scss';

interface Props {
  headerNum: number;
  headerText: string;
  className?: string;
}

export default function ContentSection({
  children,
  headerNum,
  headerText,
  className = ''
}: PropsWithChildren<Props>): ReactElement {
  const base = colorHex('primary', 'base');
  const backgroundColor = mixWithWhite(base, 0.92);
  const headerStyle = useMemo(() => ({ backgroundColor }), [base]);

  return (
    <div className={`content-section ${className}`}>
      <div
        className={`header-area ${fontColorClassFromBgColor(backgroundColor)} ${fontTypo('headline')}`}
        style={headerStyle}
      >
        <span className={`header-number ${colorBgAutoFont('primary', 'base')}`}>
          {headerNum}
        </span>
        {headerText}
      </div>
      <div className="content-area">{children}</div>
    </div>
  );
}
